/**
 * Returns a fields label.
 *
 * @param field The field to parse for a label.
 * @returns string The fields label.
 */
const getFieldLabel = (field) =>
	$(field).parents('.form-group').find('label').text() ||
	$(field).attr('name');

export default getFieldLabel;
